import type { Country as CountryCode } from '@tectonics/prs/country';
import { getPhoneNumberNormalizerWithLength } from '@tectonics/commons/customer-form/get-phone-number-normalizer';
import type { Country } from './country';

const DEFAULT_PHONE_NUMBER_NORMALIZER = getPhoneNumberNormalizerWithLength(20);

export function createDefaultCountry(code: CountryCode): Country {
  return {
    code,
    customerForm: {
      phoneNumber: {
        normalizer: DEFAULT_PHONE_NUMBER_NORMALIZER,
      },
    },
  };
}
